const Endpoint = {
  HAS_VALID_LICENSE: '/default/administration-menu/has-valid-license',
  GET_MENU: '/default/administration-menu/get-menu',
  GET_SYSTEM_IMAGE: '/default/administration-menu/get-system-image',
  GET_SYSTEM_NAME: '/default/administration-menu/get-system-name',
};

export default Endpoint;
